import { Space, Dropdown } from "antd";
import { Menu as MenuIcon } from "@/components/Icons";
// project import
import Search from "./Search";
import Profile from "./Profile";
import Notification from "./Notification";
import ScheduleNotification from "./ScheduleNotification";
import AlertNotification from "./AlertNotification";
import LanguageSelector from "./LanguageSelector";
import PlantSelector from "@/components/PlantSelector";
import BatchCalendarIcon from "./BatchCalendarIcon";
import ThemeToggle from "@/components/ThemeToggle";
import FontSizeToggle from "@/components/FontSizeToggle";
import { useTheme } from "@/App";
import { useResponsive } from '@/hooks/useResponsive';

// ==============================|| HEADER - CONTENT ||============================== //

const HeaderContent = ({ isMobile = false, isTablet = false, isDesktop = true }) => {
  const { isDark, toggleTheme } = useTheme();

  // Mobile view - Dropdown menu for most actions
  if (isMobile) {
    return (
      <Space size="small" className="flex items-center">
        {/* Theme Toggle - Always visible */}
        <ThemeToggle isDark={isDark} onToggle={toggleTheme} />

        {/* Search - Hidden on mobile, accessible via dropdown */}
        {/* <Search isMobile={isMobile} /> */}

        {/* Critical notifications */}
        <AlertNotification isMobile={isMobile} />

        {/* Profile Menu */}
        <Profile isMobile={isMobile} />
      </Space>
    );
  }

  // Tablet view - Condensed icons
  if (isTablet) {
    return (
      <Space size="small" className="flex items-center">
        {/* Search */}
        <Search isTablet={isTablet} />

        {/* Plant Selector */}
        <PlantSelector isCompact={true} />

        {/* Theme Toggle */}
        <ThemeToggle isDark={isDark} onToggle={toggleTheme} />

        {/* Font Size */}
        <FontSizeToggle />

        {/* Notifications */}
        <Notification isTablet={isTablet} />
        <AlertNotification isTablet={isTablet} />

        {/* Profile */}
        <Profile isTablet={isTablet} />
      </Space>
    );
  }

  // Desktop view - Full layout
  return (
    <Space size={8} className="flex items-center">
      {/* Search */}
      <Search />

      {/* Plant Selector - Shows current plant and allows switching */}
      <PlantSelector />

      {/* Batch Calendar */}
      <BatchCalendarIcon />

      {/* Language Selector */}
      <LanguageSelector />

      {/* Theme Toggle */}
      <ThemeToggle isDark={isDark} onToggle={toggleTheme} />

      {/* Font Size */}
      <FontSizeToggle />

      {/* Notifications */}
      <Notification />
      <AlertNotification />
      <ScheduleNotification />

      {/* Profile */}
      <Profile />
    </Space>
  );
};

export default HeaderContent;
